/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable react/button-has-type */
/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import DealerSearchModal from './dealer-search-modal';
import { FormattedMessage } from 'react-intl';
import Modal from '../../../../sharedmodules/state/modal';
import PropTypes from 'prop-types';
import React from 'react';
import { stripSpaces } from '../../shared/services/strip-spaces';

function handleChange(event, props) {

    const processedValue = stripSpaces(event.target.value);

    props.onAccountLookupChange(processedValue);

}

function handleKeyPress(event, props) {

    if (event.key === 'Enter' || event.key === 'Tab') {

        const processedValue = stripSpaces(event.target.value);

        props.onAccountLookupBlur(processedValue);

    }

}

function handleFocus(event) {

    if (event.target.value) {

        event.target.select();

    }

}

const DealerSearchLink = (props) => (
    <div className="dealer-search-link">
        {
            props.account ? (
                <span
                    className="icon-search"
                    onClick={props.onResetClick}
                />
            ) :
                (
                    <div className="dealer-search-controls">
                        <input
                            autoFocus
                            className="dealer-search-input"
                            onChange={(e) => handleChange(e, props)}
                            onFocus={(e) => handleFocus(e)}
                            onKeyDown={(e) => handleKeyPress(e, props)}
                            type="text"
                            value={props.accountLookup}
                        />
                        <span className="dealer-search-or"><FormattedMessage id="OR" /></span>
                        <button
                            className="dealer-search-button"
                            onClick={props.onDealerSearchViewClick}
                        >
                            <span className="icon-search-small" />
                            <FormattedMessage id="DEALER_SEARCH" />
                        </button>
                    </div>
                )
        }
        <DealerSearchModal
            isOpen={props.dealerSearchModal.isVisible}
            onClose={props.onDealerSearchViewClick}
        />
    </div>
);

DealerSearchLink.displayName = 'DealerSearchLink';
DealerSearchLink.propTypes = {
    account: PropTypes.string.isRequired,
    accountLookup: PropTypes.string.isRequired,
    dealerSearchModal: PropTypes.instanceOf(Modal).isRequired,
    onAccountLookupBlur: PropTypes.func.isRequired,
    onAccountLookupChange: PropTypes.func.isRequired,
    onDealerSearchViewClick: PropTypes.func.isRequired,
    onResetClick: PropTypes.func.isRequired,
};

export default DealerSearchLink;
